export default __webpack_public_path__ + "static/media/4T0A9781.c2e92e34.jpg";